<template>
  <div>
    <Breadcrumbs title="Analytics" main="Research"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-7">
          <div class="card">
            <table role="table" aria-busy="false" aria-colcount="4"
                   class="table b-table table-striped table-hover">
              <thead role="rowgroup" class="">
              <tr role="row" class="">
                <th>#</th>
                <th>Part Number</th>
                <th>Sold</th>
                <th>Min Price</th>
                <th>Avg Price</th>
                <th>Max Price</th>
              </tr>
              </thead>
              <tbody role="rowgroup">
              <tr role="row" v-for="(product, index) in competitorProducts" :key="index"
                  :class="{ 'bg-light': index === selectedProduct }">
                <td style="cursor:pointer;"><span
                    @click="showAllProducts(product.part_number); selectedProduct = index;">{{ index }}</span>
                </td>
                <td>
                  <router-link
                      :to="'/catalog/search-part?part_number=' + product.part_number"
                      custom
                      v-slot="{ href, route, navigate, isActive, isExactActive }"
                  >
                    <a :href="href" @click="navigate" target="_blank">{{ product.part_number }}</a>
                  </router-link>
                </td>
                <td>{{ product.sold }}</td>
                <td>${{ product.min_price }}</td>
                <td>${{ product.avg_price }}</td>
                <td>${{ product.max_price }}</td>
              </tr>
              </tbody>
            </table>

            <b-pagination
                v-model="currentPage"
                :total-rows="totalRows"
                :per-page="perPage"
                class="my-0"
            ></b-pagination>
          </div>
        </div>

        <div class="col-md-5">
          <div class="card">
            <div class="table-responsive mb-4">
              <table role="table" aria-busy="false" aria-colcount="4"
                     class="table b-table table-striped table-hover">
                <thead role="rowgroup" class="">
                <tr role="row" class="">
                  <th>Date</th>
                  <th>Brand</th>
                  <th>Competitor</th>
                  <th>Price</th>
                </tr>
                </thead>
                <tbody role="rowgroup">
                <tr role="row" v-for="(productForPart, index) in productsByPart" :key="index">
                  <td>{{ productForPart.date }}</td>
                  <td>{{ productForPart.brand }}</td>
                  <td>{{ productForPart.competitor }}</td>
                  <td>${{ productForPart.price }}</td>
                </tr>
                </tbody>
              </table>
            </div>

            <b-pagination
                v-model="currentPageInPartDetails"
                :total-rows="totalRowsInPartDetails"
                :per-page="perPage"
                class="my-0"
            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {competitorProductAnalytics} from "../../../_services";

export default {
  data: function () {
    return {
      currentPage: 1,
      currentPageInPartDetails: 1,
      perPage: 10,
      totalRows: null,
      totalRowsInPartDetails: null,
      competitorProducts: null,
      selectedProduct: null,
      productsByPart: null
    }
  },
  watch: {
    currentPage: function () {
      this.getList();
    }
  },
  created() {
    this.getList();
  },
  methods: {
    showAllProducts(partNumber) {
      competitorProductAnalytics.getProductsByPartNumber(
          partNumber,
          this.perPage,
          this.currentPageInPartDetails
      )
          .then(
              async response => {
                this.productsByPart = response.data.competitor_products;
                this.totalRowsInPartDetails = response.data.count;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
    getList() {
      competitorProductAnalytics.getList(
          this.perPage,
          this.currentPage
      )
          .then(
              async response => {
                this.competitorProducts = response.data.grouped_competitor_products;
                this.totalRows = response.data.count;
              },
              error => {
                const {dispatch} = this.$store;
                dispatch('alert/error', error, {root: true});
              }
          );
    },
  }
}
</script>
